import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicFormControl } from '../model/dynamic-form-control.model';

@Injectable({ providedIn: 'root' })
export class DynamicFormService {

    constructor(private fb: FormBuilder) {

    }

    toFormGroup(formStructure: DynamicFormControl[]): FormGroup {
      let formGroup = {};
      formStructure.forEach(control => {
        formGroup[control.name] = [control.value || null, this.buildValidators(control)];
      });
      return this.fb.group(formGroup);
    }

    buildValidators(control: DynamicFormControl): any[] {
      let validators = [];
      control.validations?.forEach(validation => {
        if (validation.validator === 'required') validators.push(Validators.required);
      });
      if (control.maxLength) validators.push(Validators.maxLength(control.maxLength));
      return validators;
    }
}
